import { Injectable, inject } from '@angular/core';
import {
  AssignmentPriorityService as AssignmentPriorityApi,
  ChangeAssignmentPriorityRequest,
} from '@6grain/masofa-monolith-api-client/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Changes one assignment priority through the generated common client. */
@Injectable({ providedIn: 'root' })
export class AssignmentPriorityService {
  private readonly api = inject(AssignmentPriorityApi);

  change(assignmentId: string, priority: string): Observable<void> {
    const body: ChangeAssignmentPriorityRequest = {
      priority: priority as ChangeAssignmentPriorityRequest.PriorityEnum,
    };
    return this.api.assignmentsAssignmentIdPriorityPatch(assignmentId, body).pipe(map(() => undefined));
  }
}
